var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Transition',{attrs:{"name":"spinner-fade"}},[(_vm.fetching)?_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"lds-ellipsis"},[_c('div'),_c('div'),_c('div'),_c('div')])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }